import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Tabs = makeShortcode("Tabs");
const Tab = makeShortcode("Tab");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Pre-requisites</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Introduction</AnchorLink>
  <AnchorLink mdxType="AnchorLink">ArgoCD Installation</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Deploying the Application</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Verifying the deployment</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Using the ArgoCD CLI</AnchorLink>
  <AnchorLink mdxType="AnchorLink">References</AnchorLink>
    </AnchorLinks>
    <Tabs mdxType="Tabs">
      <Tab label="OpenShift" mdxType="Tab">
        <h2>{`Pre-requisites`}</h2>
        <p>{`Make sure your environment is setup properly for the lab.`}</p>
        <p>{`Check the `}<a parentName="p" {...{
            "href": "../../../getting-started/devenvsetup"
          }}>{`Environment Setup`}</a>{` page for your setup.`}</p>
        <h2>{`ArgoCD Installation`}</h2>
        <ul>
          <li parentName="ul">{`Create the namespace `}<inlineCode parentName="li">{`argocd`}</inlineCode>{` to install argocd`}<pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`oc new-project argocd
`}</code></pre></li>
          <li parentName="ul">{`Install ArgoCD as follows.`}<pre parentName="li"><code parentName="pre" {...{}}>{`oc apply --filename https://raw.githubusercontent.com/ibm-cloud-architecture/learning-cloudnative-101/master/static/yamls/argo-lab/argocd-operator.yaml
`}</code></pre></li>
          <li parentName="ul">{`When installing the tutorial, make sure you wait until the argocd-operator is finished before installing the argocd-cr..or it will fail. You can do this:`}<pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`oc get ClusterServiceVersion/argocd-operator-helm.v0.0.3 -n argocd
NAME                          DISPLAY                   VERSION   REPLACES                      PHASE
argocd-operator-helm.v0.0.3   Argo CD Operator (Helm)   0.0.3     argocd-operator-helm.v0.0.2   Succeeded
`}</code></pre>{`  and wait for the “succeeded” to come up before proceeding.`}<pre parentName="li"><code parentName="pre" {...{}}>{`oc apply --filename https://raw.githubusercontent.com/ibm-cloud-architecture/learning-cloudnative-101/master/static/yamls/argo-lab/argocd-cr.yaml
`}</code></pre></li>
          <li parentName="ul">{`Install the `}<inlineCode parentName="li">{`argocd`}</inlineCode>{` CLI, for example on OSX use brew`}<pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`brew tap argoproj/tap
brew install argoproj/tap/argocd
`}</code></pre></li>
          <li parentName="ul">{`Set an environment variable `}<inlineCode parentName="li">{`ARGOCD_URL`}</inlineCode>{` using the `}<inlineCode parentName="li">{`EXTERNAL-IP`}</inlineCode><pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`export ARGOCD_SERVER="$(oc get route argocd-server -n argocd -o jsonpath='{.status.ingress[0].host}')"
export ARGOCD_URL="https://$ARGOCD_SERVER"
echo ARGOCD_URL=$ARGOCD_URL
echo ARGOCD_SERVER=$ARGOCD_SERVER
`}</code></pre></li>
        </ul>
        <h2>{`Deploying the app`}</h2>
        <ul>
          <li parentName="ul">{`Login into the UI.`}<pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`open $ARGOCD_URL
`}</code></pre></li>
          <li parentName="ul">{`Use `}<inlineCode parentName="li">{`admin`}</inlineCode>{` as the username and get the password with the following command, it’s the name of the pod for the argo-server`}<pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`oc get pods -n argocd -l app.kubernetes.io/name=argocd-server -o name | cut -d'/' -f 2
`}</code></pre>{`  For example the output is similar to this:`}<pre parentName="li"><code parentName="pre" {...{}}>{`argocd-server-b54756f69-jncc9
`}</code></pre></li>
        </ul>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "53.81944444444444%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAACeUlEQVQoz1XRW1MScRgGcL5NkyUqoJyXFXZZ2EXOKuApzY3QQNFAPKTmKcYpy5rptvuu+hAdPFY3Tpk1ddMXaJrJTHh69w8y487sxV7sb57neXVXmhRcbQ6iSR/GtdYomg3d0Bt6oDcm0NqegsE8AINlECb7MMzcKKyuNGydGbi8ORhsKt7sHEF7/v48QbVyDh2DWghqi6PF2IsWUwJWbgSd3gzc0hhEOQupKw9RmYSNvw2HexxOIYtO/xRMzkwDPPv9C9VqFbrrBOmNPZQmibaOPkozgA7HMGyuUZgpjZkATqBXzDKI806A901BCBRh4XN4ewGeV2qglqitI8Ugk3UI7Vo1xwhMXBqhSB6p+CSsYp7QLFxSnpJNw60UIYXmYBOm8G7vU63y2b8aaDD3w3gBOW/C4rpF6VRY5Fm8Kpdx/GQBUnIdPGEepUDJShCDc/BHF+GUZrCz/5mBfwjUHl27/QZVJIhTYeXTsLvHwHnGYRILeFkq4GhjAkJkkaXSIG9oAT76DnSvgJfnsXvwhUGVSr2yWYPql3N4tK1y4Gknu1zCC3UIr+9E6ed7hM0zyB9dhhJfQSixAU9wGbuHJww8pw1ZQgbVL+fyTrLBed80lNg8MuoccuoMEoOrkCJLDAr0rKEr8QCR/k14I2vYO/x6GWxcjg1+l3YqQugq0TsLgVKJ4SVKtlyDejcQSpYR7ttEfGgLvngZ+++/NUBWuXE5udgYXAovULUlyLH7VHeVQUENSm1SsoeIDT5G78hTKIlHOPjwvb5htZbQLRfgCcxcGtwf03ZapVTrCFK9Cyg6sEXJttE9/AxJ9TmCfds4/PijduXTU5bwP4/dCCEkOwCaAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "ArgoCD Login",
            "title": "ArgoCD Login",
            "src": "/ibm-cloudnative-journey/static/30fe4e9c7b5cce19f88155110ad1896d/3cbba/argocd_login.png",
            "srcSet": ["/ibm-cloudnative-journey/static/30fe4e9c7b5cce19f88155110ad1896d/7fc1e/argocd_login.png 288w", "/ibm-cloudnative-journey/static/30fe4e9c7b5cce19f88155110ad1896d/a5df1/argocd_login.png 576w", "/ibm-cloudnative-journey/static/30fe4e9c7b5cce19f88155110ad1896d/3cbba/argocd_login.png 1152w", "/ibm-cloudnative-journey/static/30fe4e9c7b5cce19f88155110ad1896d/96c52/argocd_login.png 1571w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <ul>
          <li parentName="ul">{`Now go back to the ArgoCD home and click on `}<inlineCode parentName="li">{`NEW APP`}</inlineCode>{`.`}</li>
          <li parentName="ul">{`Add the below details:`}</li>
          <li parentName="ul">{`Application Name: `}<inlineCode parentName="li">{`sample`}</inlineCode></li>
          <li parentName="ul">{`Project - `}<inlineCode parentName="li">{`default`}</inlineCode></li>
          <li parentName="ul">{`SYNC POLICY: `}<inlineCode parentName="li">{`Manual`}</inlineCode></li>
          <li parentName="ul">{`REPO URL: `}<inlineCode parentName="li">{`https://github.com/ibm-cloud-architecture/cloudnative_sample_app_deploy`}</inlineCode></li>
          <li parentName="ul">{`Revision: `}<inlineCode parentName="li">{`HEAD`}</inlineCode></li>
          <li parentName="ul">{`Path: `}<inlineCode parentName="li">{`openshift`}</inlineCode></li>
        </ul>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "54.166666666666664%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAABPUlEQVQoz42S20rDQBCG9wUVBdNQLaJXoleib+GNIoq2KaElnl9FFERUEBGvBG3TVN00h93kdzYkNjEeMvAzS7L7zb87wxq6hj3DRKtt4vj0DOdXN7i8f8QrH8F553A+qullMMRzzwabnJrG5m4TG1s72N438EY/4zhGFEWkuIIixADuHp5wcX0LNkFA0zpCu2uhc3iCnj3AyPMQETSuKoKq8Ogc02o6jI6FptlNwAoowjB1WE0yD5zRauTu4AtoO0NIKau7SzUG1spAQcBMsoLUPuXU830wvV4vAPvKIT12EAqEQhYUCJF8/01+EILNzjVKDn2qJOjwd0XkJInkiqlyV1Yu2fzCYgGomsI5h+u6SeaUs7UqNB6pclNUZkvLKyWHWcWf4q/GSEnA1bX1wtj0c2OTPXq2/nd8aM8nmtwnmGJ0cY0AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "app details one",
            "title": "app details one",
            "src": "/ibm-cloudnative-journey/static/59ae416e31ac0c0d6526258e1634f6e5/3cbba/app_argo_1.png",
            "srcSet": ["/ibm-cloudnative-journey/static/59ae416e31ac0c0d6526258e1634f6e5/7fc1e/app_argo_1.png 288w", "/ibm-cloudnative-journey/static/59ae416e31ac0c0d6526258e1634f6e5/a5df1/app_argo_1.png 576w", "/ibm-cloudnative-journey/static/59ae416e31ac0c0d6526258e1634f6e5/3cbba/app_argo_1.png 1152w", "/ibm-cloudnative-journey/static/59ae416e31ac0c0d6526258e1634f6e5/0b124/app_argo_1.png 1728w", "/ibm-cloudnative-journey/static/59ae416e31ac0c0d6526258e1634f6e5/4ea69/app_argo_1.png 2304w", "/ibm-cloudnative-journey/static/59ae416e31ac0c0d6526258e1634f6e5/0d3df/app_argo_1.png 3141w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <ul>
          <li parentName="ul">{`Cluster - Select the default one `}<inlineCode parentName="li">{`https://kubernetes.default.svc`}</inlineCode>{` to deploy in-cluster`}</li>
          <li parentName="ul">{`Namespace - `}<inlineCode parentName="li">{`default`}</inlineCode></li>
          <li parentName="ul">{`Click Create to finish`}</li>
        </ul>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.43055555555556%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABLElEQVQoz5WRwU6DQBCGeUCjpkIjaWJ6NH0UL8akTVppsK0l1EfxogdPHnyBRkqBBRZ24e/sNiHhYIRJ/sxhZ76Znd+wrQGmcwfzZweev8P75xc+vn+wTxgOxxiHqLt+wwjG5dU1HmcLPDxNMXNcsCyDFBJSSvQNQT3GBQHdjYfl6hUb/w1BeARjTEsIgbquUVfV/6K6kuoN0xrCIdjCXWPl7RDQ6ik9iBooqLCXFHBgmliutw1wH4RIMo44zRFn3ZWoTD3GjWW1gAEdNs25nlaUArw85y7KeAFjeGs3wJetjyTNkOc5OOf60FVV9zPFHo3aQJaiVJvRNBWMBihzVGiD/pAKbcrdeEymtIFCf7fURVGi3JbdgfeTSePy+cupfpSy0jkk19XG3YASJ7n+3VIREJLQAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "app details two",
            "title": "app details two",
            "src": "/ibm-cloudnative-journey/static/39813c22bfaccabf506ce07d24062289/3cbba/app_argo_2.png",
            "srcSet": ["/ibm-cloudnative-journey/static/39813c22bfaccabf506ce07d24062289/7fc1e/app_argo_2.png 288w", "/ibm-cloudnative-journey/static/39813c22bfaccabf506ce07d24062289/a5df1/app_argo_2.png 576w", "/ibm-cloudnative-journey/static/39813c22bfaccabf506ce07d24062289/3cbba/app_argo_2.png 1152w", "/ibm-cloudnative-journey/static/39813c22bfaccabf506ce07d24062289/0b124/app_argo_2.png 1728w", "/ibm-cloudnative-journey/static/39813c22bfaccabf506ce07d24062289/4ea69/app_argo_2.png 2304w", "/ibm-cloudnative-journey/static/39813c22bfaccabf506ce07d24062289/b5501/app_argo_2.png 3149w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <ul>
          <li parentName="ul">{`You will now see the available apps.`}</li>
        </ul>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "34.72222222222222%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAABYlAAAWJQFJUiTwAAABFklEQVQoz42Q2U7CQBSG+8iaEC9QgcirKTcGY8Q0EVDUlqXrdKPtdEo+pzUYjYpefJmTmcm/HGPY62LOF8wXr1irNUqplqqqPuZD1Jqt/iuyHDdOMY47Ha7vp4xuTcbmDC9KCOKMMNkSJFk7uyLB+YXmbRnEPHuCFz/COOqcINKcbVkRpSmut6SsFLKSqLqmrndYTsDU2jC3HWY/0NxPGywH47w/wBcxeVHomiVh2NTeURT5eyUtanshj0uXp5X3J0b3rNcKFqVEygLHtRF6FyJOSNKsFV35Qqf4LtiY7I32s3Ha67PxQ4TenVIV5uyBy/GE0c2Eq/Ed9sbTglFb618JBxdD3CAiinVKKVms/S/s3T+fh3gDsMQDpdnzrqIAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "sampleapp create",
            "title": "sampleapp create",
            "src": "/ibm-cloudnative-journey/static/eddb5c8846254c4846d2507394ff8490/3cbba/sampleapp_create.png",
            "srcSet": ["/ibm-cloudnative-journey/static/eddb5c8846254c4846d2507394ff8490/7fc1e/sampleapp_create.png 288w", "/ibm-cloudnative-journey/static/eddb5c8846254c4846d2507394ff8490/a5df1/sampleapp_create.png 576w", "/ibm-cloudnative-journey/static/eddb5c8846254c4846d2507394ff8490/3cbba/sampleapp_create.png 1152w", "/ibm-cloudnative-journey/static/eddb5c8846254c4846d2507394ff8490/0b124/sampleapp_create.png 1728w", "/ibm-cloudnative-journey/static/eddb5c8846254c4846d2507394ff8490/4ea69/sampleapp_create.png 2304w", "/ibm-cloudnative-journey/static/eddb5c8846254c4846d2507394ff8490/74fc2/sampleapp_create.png 3138w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <ul>
          <li parentName="ul">{`Initially, the app will be out of sync. It is yet to be deployed. You need to sync it for deploying.`}</li>
        </ul>
        <p>{`To sync the application, click `}<inlineCode parentName="p">{`SYNC`}</inlineCode>{` and then `}<inlineCode parentName="p">{`SYNCHRONIZE`}</inlineCode>{`.`}</p>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "51.041666666666664%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABu0lEQVQoz5WSy28SURSH5+9TohZRsYnRneFPscZIFJCCwHSeQKd3Bli5d6VCyBS2hrRaXgMzwyt9LH4994YaadMFiy/33pOcL+dxpXgsikyugHyxBFlRUa/XUavVNuCxRqMBx7bxq+3i2/efcH+fYBDMMQ5mGIdzgUdIDx5G8CH1Be8/ZfAxnYVmlqGXqxsoRhmqWUHhQEXT7WA4W+JkNEFv6OHU89H3ZzgjvNkCUuTRY5FkMRuVwypUTcYRc8CoGsdxBEVVR05WkcoV8aPVRrBYwqdkwXyJYA1/S09jz6DqJg4tC4xZMAwFtlODxd8ktW0HJc1A/kBHJk/CdgenIx+9vwP8GXnoj6foT3ycTUMM/BDSk52oEFpHTAgVpQidWlQ0neIGxWzImklCDem1cByuMCDJiCSc4TQgQngBCaOxGGRVI4lJ1TCk97N4l0xhL/lZUFK0f8IUCVvHXawurjBdt7vRMiE9fxEXlVQqVZqdja+KvgEX8fnxOxc23S4W55eY0Ea59DZS/OUuLcMS34PPLE/JuVtw6X3CmypvkF69fiOEfJtCuK7o/3Mr4dtEQgj5Ni3G7oi2FV4DlQmB4d0hPvIAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "out of sync",
            "title": "out of sync",
            "src": "/ibm-cloudnative-journey/static/1910af2de6a3b8ba8fe6293f157d24a5/3cbba/out_of_sync.png",
            "srcSet": ["/ibm-cloudnative-journey/static/1910af2de6a3b8ba8fe6293f157d24a5/7fc1e/out_of_sync.png 288w", "/ibm-cloudnative-journey/static/1910af2de6a3b8ba8fe6293f157d24a5/a5df1/out_of_sync.png 576w", "/ibm-cloudnative-journey/static/1910af2de6a3b8ba8fe6293f157d24a5/3cbba/out_of_sync.png 1152w", "/ibm-cloudnative-journey/static/1910af2de6a3b8ba8fe6293f157d24a5/23e4c/out_of_sync.png 1578w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <ul>
          <li parentName="ul">{`Wait till the app is deployed.`}</li>
        </ul>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "51.041666666666664%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABS0lEQVQoz5WS2U7CQBSG+75GTQxR3CJGL4zeG30hvHCJC0YDghRa6Uw7U5aW7v0904hBXMBJvsxJm/nOPz3VKtsbeG7peO2YMC0OtfI8/8K8FWU5RkEE6QfQlpZXcFmr4+LuCVePDTB3CDEYEV6BQzWTA1jiF+id4fTR5hK67UJbXStBDD0EUQzpBdB5H3EcI4oTJGmGlOgwgXqX4cXgBPtGk543aFdom1s74MJFGIYYRwkMMSRJCi8IEJI4odqg7k2To/Vmz0UrrZdhyz58fwyfhC1LQrouLFvApkYqrUlXUelmD6smk0aTWitTwh4XcISkRClu6zqq1/eo3tSIB3Qt+0PIFku4u1cBcyQ8z6fvFqPdc9C2xCeT7tP7n8L9g0OMaNx5lhWDmI4/e6WFEh4dnxRCNYh4SjgrWVh4enZeCNU01a/zn8M/8Q7Xwt9i+0+CUwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "synched app",
            "title": "synched app",
            "src": "/ibm-cloudnative-journey/static/03f918ce36943230732e63f4259706af/3cbba/synched_app.png",
            "srcSet": ["/ibm-cloudnative-journey/static/03f918ce36943230732e63f4259706af/7fc1e/synched_app.png 288w", "/ibm-cloudnative-journey/static/03f918ce36943230732e63f4259706af/a5df1/synched_app.png 576w", "/ibm-cloudnative-journey/static/03f918ce36943230732e63f4259706af/3cbba/synched_app.png 1152w", "/ibm-cloudnative-journey/static/03f918ce36943230732e63f4259706af/ba1f3/synched_app.png 1574w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <ul>
          <li parentName="ul">{`Once the app is deployed, click on it to see the details.`}</li>
        </ul>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "39.583333333333336%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsSAAALEgHS3X78AAABVElEQVQoz22Q63KCMBCFeeNWW2s7vbxjdaa2IoRbJAkQIFzUP54u8VY7MvPNZje7Z09w3qYPmLk+VkGErCjhBzFWLMLSD4kALkWPai4LLV3fY7fbYbs9MJybrofUFVLCuR+N8OX54CJD228w8xjlAWIusCCBT7qbMwYvShDxFLe+/X5/iIRzNxqjbHvU7QZV00FVBlnVwPRbFKaFKGtkpoE2HUy3QUlR1y3lt3EeJ1MsY0FIrBIJjyv8RCm+w5SiQEDORV5CFBVCkR97L7g09xfr0F8rGiww92IsgsS6yeuGavlZkKsCQZrZ3iFfZxqJ0pRnVzjjx4l1xdKcxDgWIYcsDQlo6zjJtV0gdY2IFjASTfMKsSzgc2lFhvlhkU/ReXp+ORYPGxjhJsPzlW0cXKxJTNF/ldrY2ulumDmIXaLz+v5xVTydT9haoqzbgf93ZzPH8y/FdUhwIfQGjgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "sample app deployed",
            "title": "sample app deployed",
            "src": "/ibm-cloudnative-journey/static/ed3d6351842156b1ad02675f43c47981/3cbba/sample_app_deployed.png",
            "srcSet": ["/ibm-cloudnative-journey/static/ed3d6351842156b1ad02675f43c47981/7fc1e/sample_app_deployed.png 288w", "/ibm-cloudnative-journey/static/ed3d6351842156b1ad02675f43c47981/a5df1/sample_app_deployed.png 576w", "/ibm-cloudnative-journey/static/ed3d6351842156b1ad02675f43c47981/3cbba/sample_app_deployed.png 1152w", "/ibm-cloudnative-journey/static/ed3d6351842156b1ad02675f43c47981/23e4c/sample_app_deployed.png 1578w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "28.819444444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAAsSAAALEgHS3X78AAABH0lEQVQY021P2Y6DMBDj/z+uD7tqpQJJICQcgXJDu6u2XieobxvJmngyYzvRWWpIbdFPC7StkRUlRG4OZEXgmSmRKI1pWeHP6/XG+33g+Xxi2e9o5xXrzy+ii5AwVYNtf+Cc5fhOJHJT4ZprnJIUX0pCFBaSBtu+47/jhUMlomm7YybGZYMbZ7hhpuMDI3s1726a0U0rPnMD54Z5Q89Evga+HNxrRBdlEWt+teqg6xtE6SArh7ob4PoJxvVQZYuK/IPUOsRFjSv3fI2LBgkh2I9OV4VLZkKqnklU1UI3HcXGsJyT+15zGwNMc5gWrDW5bXvO3yBp6kNF3l0QqXEEnQzTUrDqRibmG3upbbg4hGVlm5DQC3pD5X9ELqw37vAHt2zBs7cBahEAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "sample app full deployment",
            "title": "sample app full deployment",
            "src": "/ibm-cloudnative-journey/static/72416f00d3f584833043748ee2a28954/3cbba/sample_app_full_deployment.png",
            "srcSet": ["/ibm-cloudnative-journey/static/72416f00d3f584833043748ee2a28954/7fc1e/sample_app_full_deployment.png 288w", "/ibm-cloudnative-journey/static/72416f00d3f584833043748ee2a28954/a5df1/sample_app_full_deployment.png 576w", "/ibm-cloudnative-journey/static/72416f00d3f584833043748ee2a28954/3cbba/sample_app_full_deployment.png 1152w", "/ibm-cloudnative-journey/static/72416f00d3f584833043748ee2a28954/a8e2d/sample_app_full_deployment.png 1577w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <h2>{`Verifying the deployment`}</h2>
        <ul>
          <li parentName="ul">{`Access the app to verify if it is correctly deployed.`}</li>
          <li parentName="ul">{`List the cloudnativesampleapp-service route`}<pre parentName="li"><code parentName="pre" {...{}}>{`oc get route
`}</code></pre>{`  It should have an IP under `}<inlineCode parentName="li">{`EXTERNAL-IP`}</inlineCode>{` column`}<pre parentName="li"><code parentName="pre" {...{}}>{`NAME                 HOST/PORT                                     PATH   SERVICES                       PORT   TERMINATION   WILDCARD
cloudnative-sample   cloudnative-sample-default.apps-crc.testing          cloudnativesampleapp-service   9080                 None
`}</code></pre></li>
          <li parentName="ul">{`Set an environment variable `}<inlineCode parentName="li">{`APP_URL`}</inlineCode>{` using the `}<inlineCode parentName="li">{`EXTERNAL-IP`}</inlineCode><pre parentName="li"><code parentName="pre" {...{}}>{`export APP_URL="http://$(oc get route cloudnative-sample -o jsonpath='{.status.ingress[0].host}')"
echo ARGOCD_SERVER=$APP_URL
`}</code></pre></li>
          <li parentName="ul">{`Access the url using `}<inlineCode parentName="li">{`curl`}</inlineCode><pre parentName="li"><code parentName="pre" {...{}}>{`curl "$APP_URL/greeting?name=Carlos"
`}</code></pre><pre parentName="li"><code parentName="pre" {...{}}>{`{"id":2,"content":"Welcome to Cloudnative bootcamp !!! Hello, Carlos :)"}
`}</code></pre></li>
        </ul>
        <h2>{`Using the ArgoCD CLI`}</h2>
        <ul>
          <li parentName="ul">
            <p parentName="li">{`Login using the cli.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Login as the `}<inlineCode parentName="p">{`admin`}</inlineCode>{` user.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`The initial password is autogenerated to be the pod name of the Argo CD API server. This can be retrieved with the following command.`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`oc get pods -n argocd -l app.kubernetes.io/name=argocd-server -o name | cut -d'/' -f 2
`}</code></pre>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Now login as follows.`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`argocd login $ARGOCD_SERVER
`}</code></pre>
            <pre parentName="li"><code parentName="pre" {...{}}>{`WARNING: server certificate had error: x509: cannot validate certificate for 10.97.240.99 because it doesn't contain 
any IP SANs. Proceed insecurely (y/n)? y
Username: admin
Password: 
'admin' logged in successfully
Context '10.97.240.99' updated
`}</code></pre>
          </li>
          <li parentName="ul">
            <p parentName="li">{`List the applications`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`argocd app list
`}</code></pre>
            <pre parentName="li"><code parentName="pre" {...{}}>{`NAME    CLUSTER                         NAMESPACE  PROJECT  STATUS  HEALTH   SYNCPOLICY  CONDITIONS  REPO                                                                     PATH   TARGET
sample  https://kubernetes.default.svc  default    default  Synced  Healthy  <none>      <none>      https://github.com/ibm-cloud-architecture/cloudnative_sample_app_deploy  openshift  HEAD
`}</code></pre>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Get application details`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`argocd app get sample
`}</code></pre>
            <pre parentName="li"><code parentName="pre" {...{}}>{`Name:               sample
Project:            default
Server:             https://kubernetes.default.svc
Namespace:          default
URL:                https://10.97.240.99/applications/sample
Repo:               https://github.com/ibm-cloud-architecture/cloudnative_sample_app_deploy
Target:             HEAD
Path:               openshift
SyncWindow:         Sync Allowed
Sync Policy:        <none>
Sync Status:        Synced to HEAD (9684037)
Health Status:      Healthy

GROUP  KIND        NAMESPACE  NAME                             STATUS  HEALTH   HOOK  MESSAGE
    Service     default    cloudnativesampleapp-service     Synced  Healthy        service/cloudnativesampleapp-service created
apps   Deployment  default    cloudnativesampleapp-deployment  Synced  Healthy        deployment.apps/cloudnativesampleapp-deployment created
`}</code></pre>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Show application deployment history`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`argocd app history sample
`}</code></pre>
            <pre parentName="li"><code parentName="pre" {...{}}>{`ID  DATE                           REVISION
0   2020-02-12 21:10:32 -0500 EST  HEAD (9684037)
`}</code></pre>
          </li>
        </ul>
        <h2>{`References`}</h2>
        <ul>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://argoproj.github.io/argo-cd/"
            }}>{`ArgoCD`}</a></li>
        </ul>
      </Tab>
      <Tab label="IKS" mdxType="Tab">
        <h2>{`Pre-requisites`}</h2>
        <p>{`Make sure your environment is setup properly for the lab.`}</p>
        <p>{`Check the `}<a parentName="p" {...{
            "href": "../../../getting-started/devenvsetup"
          }}>{`Environment Setup`}</a>{` page for your setup.`}</p>
        <h2>{`ArgoCD Installation`}</h2>
        <ul>
          <li parentName="ul">{`Create the namespace `}<inlineCode parentName="li">{`argocd`}</inlineCode>{` to install argocd`}<pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`kubectl create namespace argocd
`}</code></pre></li>
          <li parentName="ul">{`Install ArgoCD as follows.`}<pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`kubectl apply -n argocd -f https://raw.githubusercontent.com/argoproj/argo-cd/stable/manifests/install.yaml
`}</code></pre></li>
          <li parentName="ul">{`Install the `}<inlineCode parentName="li">{`argocd`}</inlineCode>{` CLI, for example on OSX use brew`}<pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`brew tap argoproj/tap
brew install argoproj/tap/argocd
`}</code></pre></li>
          <li parentName="ul">{`To allow access via LoadBalancer and leverage the `}<inlineCode parentName="li">{`minikube tunnel`}</inlineCode>{` running in the background, patch the argocd server service`}<pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`kubectl patch svc argocd-server -n argocd -p '{"spec": {"type": "LoadBalancer"}}'
`}</code></pre></li>
          <li parentName="ul">{`List the argocd-server service`}<pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`kubectl get svc argocd-server -n argocd
`}</code></pre>{`  It should have an IP under `}<inlineCode parentName="li">{`EXTERNAL-IP`}</inlineCode>{` column`}<pre parentName="li"><code parentName="pre" {...{}}>{`NAME            TYPE           CLUSTER-IP     EXTERNAL-IP    PORT(S)                      AGE
argocd-server   LoadBalancer   10.97.240.99   10.97.240.99   80:30286/TCP,443:31716/TCP   41s
`}</code></pre></li>
          <li parentName="ul">{`Set an environment variable `}<inlineCode parentName="li">{`ARGOCD_URL`}</inlineCode>{` using the `}<inlineCode parentName="li">{`EXTERNAL-IP`}</inlineCode><pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`export ARGOCD_SERVER="$(kubectl get svc argocd-server -n argocd -o jsonpath='{.status.loadBalancer.ingress[0].ip}')"
export ARGOCD_URL="https://$ARGOCD_SERVER"
echo ARGOCD_URL=$ARGOCD_URL
echo ARGOCD_SERVER=$ARGOCD_SERVER
`}</code></pre></li>
        </ul>
        <h2>{`Deploying the app`}</h2>
        <ul>
          <li parentName="ul">{`Login into the UI.`}<pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`open $ARGOCD_URL
`}</code></pre></li>
          <li parentName="ul">{`Use `}<inlineCode parentName="li">{`admin`}</inlineCode>{` as the username and get the password with the following command, it’s the name of the pod for the argo-server`}<pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`kubectl get pods -n argocd -l app.kubernetes.io/name=argocd-server -o name | cut -d'/' -f 2
`}</code></pre>{`  For example the output is similar to this:`}<pre parentName="li"><code parentName="pre" {...{}}>{`argocd-server-b54756f69-jncc9
`}</code></pre></li>
        </ul>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "53.81944444444444%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAACeUlEQVQoz1XRW1MScRgGcL5NkyUqoJyXFXZZ2EXOKuApzY3QQNFAPKTmKcYpy5rptvuu+hAdPFY3Tpk1ddMXaJrJTHh69w8y487sxV7sb57neXVXmhRcbQ6iSR/GtdYomg3d0Bt6oDcm0NqegsE8AINlECb7MMzcKKyuNGydGbi8ORhsKt7sHEF7/v48QbVyDh2DWghqi6PF2IsWUwJWbgSd3gzc0hhEOQupKw9RmYSNvw2HexxOIYtO/xRMzkwDPPv9C9VqFbrrBOmNPZQmibaOPkozgA7HMGyuUZgpjZkATqBXzDKI806A901BCBRh4XN4ewGeV2qglqitI8Ugk3UI7Vo1xwhMXBqhSB6p+CSsYp7QLFxSnpJNw60UIYXmYBOm8G7vU63y2b8aaDD3w3gBOW/C4rpF6VRY5Fm8Kpdx/GQBUnIdPGEepUDJShCDc/BHF+GUZrCz/5mBfwjUHl27/QZVJIhTYeXTsLvHwHnGYRILeFkq4GhjAkJkkaXSIG9oAT76DnSvgJfnsXvwhUGVSr2yWYPql3N4tK1y4Gknu1zCC3UIr+9E6ed7hM0zyB9dhhJfQSixAU9wGbuHJww8pw1ZQgbVL+fyTrLBed80lNg8MuoccuoMEoOrkCJLDAr0rKEr8QCR/k14I2vYO/x6GWxcjg1+l3YqQugq0TsLgVKJ4SVKtlyDejcQSpYR7ttEfGgLvngZ+++/NUBWuXE5udgYXAovULUlyLH7VHeVQUENSm1SsoeIDT5G78hTKIlHOPjwvb5htZbQLRfgCcxcGtwf03ZapVTrCFK9Cyg6sEXJttE9/AxJ9TmCfds4/PijduXTU5bwP4/dCCEkOwCaAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "ArgoCD Login",
            "title": "ArgoCD Login",
            "src": "/ibm-cloudnative-journey/static/30fe4e9c7b5cce19f88155110ad1896d/3cbba/argocd_login.png",
            "srcSet": ["/ibm-cloudnative-journey/static/30fe4e9c7b5cce19f88155110ad1896d/7fc1e/argocd_login.png 288w", "/ibm-cloudnative-journey/static/30fe4e9c7b5cce19f88155110ad1896d/a5df1/argocd_login.png 576w", "/ibm-cloudnative-journey/static/30fe4e9c7b5cce19f88155110ad1896d/3cbba/argocd_login.png 1152w", "/ibm-cloudnative-journey/static/30fe4e9c7b5cce19f88155110ad1896d/96c52/argocd_login.png 1571w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <ul>
          <li parentName="ul">{`Now go back to the ArgoCD home and click on `}<inlineCode parentName="li">{`NEW APP`}</inlineCode>{`.`}</li>
          <li parentName="ul">{`Add the below details:`}</li>
          <li parentName="ul">{`Application Name: `}<inlineCode parentName="li">{`sample`}</inlineCode></li>
          <li parentName="ul">{`Project - `}<inlineCode parentName="li">{`default`}</inlineCode></li>
          <li parentName="ul">{`SYNC POLICY: `}<inlineCode parentName="li">{`Manual`}</inlineCode></li>
          <li parentName="ul">{`REPO URL: `}<inlineCode parentName="li">{`https://github.com/ibm-cloud-architecture/cloudnative_sample_app_deploy`}</inlineCode></li>
          <li parentName="ul">{`Revision: `}<inlineCode parentName="li">{`HEAD`}</inlineCode></li>
          <li parentName="ul">{`Path: `}<inlineCode parentName="li">{`kubernetes`}</inlineCode></li>
        </ul>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "54.166666666666664%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAABPUlEQVQoz42S20rDQBCG9wUVBdNQLaJXoleib+GNIoq2KaElnl9FFERUEBGvBG3TVN00h93kdzYkNjEeMvAzS7L7zb87wxq6hj3DRKtt4vj0DOdXN7i8f8QrH8F553A+qullMMRzzwabnJrG5m4TG1s72N438EY/4zhGFEWkuIIixADuHp5wcX0LNkFA0zpCu2uhc3iCnj3AyPMQETSuKoKq8Ogc02o6jI6FptlNwAoowjB1WE0yD5zRauTu4AtoO0NIKau7SzUG1spAQcBMsoLUPuXU830wvV4vAPvKIT12EAqEQhYUCJF8/01+EILNzjVKDn2qJOjwd0XkJInkiqlyV1Yu2fzCYgGomsI5h+u6SeaUs7UqNB6pclNUZkvLKyWHWcWf4q/GSEnA1bX1wtj0c2OTPXq2/nd8aM8nmtwnmGJ0cY0AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "app details one",
            "title": "app details one",
            "src": "/ibm-cloudnative-journey/static/59ae416e31ac0c0d6526258e1634f6e5/3cbba/app_argo_1.png",
            "srcSet": ["/ibm-cloudnative-journey/static/59ae416e31ac0c0d6526258e1634f6e5/7fc1e/app_argo_1.png 288w", "/ibm-cloudnative-journey/static/59ae416e31ac0c0d6526258e1634f6e5/a5df1/app_argo_1.png 576w", "/ibm-cloudnative-journey/static/59ae416e31ac0c0d6526258e1634f6e5/3cbba/app_argo_1.png 1152w", "/ibm-cloudnative-journey/static/59ae416e31ac0c0d6526258e1634f6e5/0b124/app_argo_1.png 1728w", "/ibm-cloudnative-journey/static/59ae416e31ac0c0d6526258e1634f6e5/4ea69/app_argo_1.png 2304w", "/ibm-cloudnative-journey/static/59ae416e31ac0c0d6526258e1634f6e5/0d3df/app_argo_1.png 3141w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <ul>
          <li parentName="ul">{`Cluster - Select the default one `}<inlineCode parentName="li">{`https://kubernetes.default.svc`}</inlineCode>{` to deploy in-cluster`}</li>
          <li parentName="ul">{`Namespace - `}<inlineCode parentName="li">{`default`}</inlineCode></li>
          <li parentName="ul">{`Click Create to finish`}</li>
        </ul>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.43055555555556%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABLElEQVQoz5WRwU6DQBCGeUCjpkIjaWJ6NH0UL8akTVppsK0l1EfxogdPHnyBRkqBBRZ24e/sNiHhYIRJ/sxhZ76Znd+wrQGmcwfzZweev8P75xc+vn+wTxgOxxiHqLt+wwjG5dU1HmcLPDxNMXNcsCyDFBJSSvQNQT3GBQHdjYfl6hUb/w1BeARjTEsIgbquUVfV/6K6kuoN0xrCIdjCXWPl7RDQ6ik9iBooqLCXFHBgmliutw1wH4RIMo44zRFn3ZWoTD3GjWW1gAEdNs25nlaUArw85y7KeAFjeGs3wJetjyTNkOc5OOf60FVV9zPFHo3aQJaiVJvRNBWMBihzVGiD/pAKbcrdeEymtIFCf7fURVGi3JbdgfeTSePy+cupfpSy0jkk19XG3YASJ7n+3VIREJLQAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "app details two",
            "title": "app details two",
            "src": "/ibm-cloudnative-journey/static/39813c22bfaccabf506ce07d24062289/3cbba/app_argo_2.png",
            "srcSet": ["/ibm-cloudnative-journey/static/39813c22bfaccabf506ce07d24062289/7fc1e/app_argo_2.png 288w", "/ibm-cloudnative-journey/static/39813c22bfaccabf506ce07d24062289/a5df1/app_argo_2.png 576w", "/ibm-cloudnative-journey/static/39813c22bfaccabf506ce07d24062289/3cbba/app_argo_2.png 1152w", "/ibm-cloudnative-journey/static/39813c22bfaccabf506ce07d24062289/0b124/app_argo_2.png 1728w", "/ibm-cloudnative-journey/static/39813c22bfaccabf506ce07d24062289/4ea69/app_argo_2.png 2304w", "/ibm-cloudnative-journey/static/39813c22bfaccabf506ce07d24062289/b5501/app_argo_2.png 3149w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <ul>
          <li parentName="ul">{`You will now see the available apps.`}</li>
        </ul>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "34.72222222222222%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAABYlAAAWJQFJUiTwAAABFklEQVQoz42Q2U7CQBSG+8iaEC9QgcirKTcGY8Q0EVDUlqXrdKPtdEo+pzUYjYpefJmTmcm/HGPY62LOF8wXr1irNUqplqqqPuZD1Jqt/iuyHDdOMY47Ha7vp4xuTcbmDC9KCOKMMNkSJFk7uyLB+YXmbRnEPHuCFz/COOqcINKcbVkRpSmut6SsFLKSqLqmrndYTsDU2jC3HWY/0NxPGywH47w/wBcxeVHomiVh2NTeURT5eyUtanshj0uXp5X3J0b3rNcKFqVEygLHtRF6FyJOSNKsFV35Qqf4LtiY7I32s3Ha67PxQ4TenVIV5uyBy/GE0c2Eq/Ed9sbTglFb618JBxdD3CAiinVKKVms/S/s3T+fh3gDsMQDpdnzrqIAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "sampleapp create",
            "title": "sampleapp create",
            "src": "/ibm-cloudnative-journey/static/eddb5c8846254c4846d2507394ff8490/3cbba/sampleapp_create.png",
            "srcSet": ["/ibm-cloudnative-journey/static/eddb5c8846254c4846d2507394ff8490/7fc1e/sampleapp_create.png 288w", "/ibm-cloudnative-journey/static/eddb5c8846254c4846d2507394ff8490/a5df1/sampleapp_create.png 576w", "/ibm-cloudnative-journey/static/eddb5c8846254c4846d2507394ff8490/3cbba/sampleapp_create.png 1152w", "/ibm-cloudnative-journey/static/eddb5c8846254c4846d2507394ff8490/0b124/sampleapp_create.png 1728w", "/ibm-cloudnative-journey/static/eddb5c8846254c4846d2507394ff8490/4ea69/sampleapp_create.png 2304w", "/ibm-cloudnative-journey/static/eddb5c8846254c4846d2507394ff8490/74fc2/sampleapp_create.png 3138w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <ul>
          <li parentName="ul">{`Initially, the app will be out of sync. It is yet to be deployed. You need to sync it for deploying.`}</li>
        </ul>
        <p>{`To sync the application, click `}<inlineCode parentName="p">{`SYNC`}</inlineCode>{` and then `}<inlineCode parentName="p">{`SYNCHRONIZE`}</inlineCode>{`.`}</p>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "51.041666666666664%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABu0lEQVQoz5WSy28SURSH5+9TohZRsYnRneFPscZIFJCCwHSeQKd3Bli5d6VCyBS2hrRaXgMzwyt9LH4994YaadMFiy/33pOcL+dxpXgsikyugHyxBFlRUa/XUavVNuCxRqMBx7bxq+3i2/efcH+fYBDMMQ5mGIdzgUdIDx5G8CH1Be8/ZfAxnYVmlqGXqxsoRhmqWUHhQEXT7WA4W+JkNEFv6OHU89H3ZzgjvNkCUuTRY5FkMRuVwypUTcYRc8CoGsdxBEVVR05WkcoV8aPVRrBYwqdkwXyJYA1/S09jz6DqJg4tC4xZMAwFtlODxd8ktW0HJc1A/kBHJk/CdgenIx+9vwP8GXnoj6foT3ycTUMM/BDSk52oEFpHTAgVpQidWlQ0neIGxWzImklCDem1cByuMCDJiCSc4TQgQngBCaOxGGRVI4lJ1TCk97N4l0xhL/lZUFK0f8IUCVvHXawurjBdt7vRMiE9fxEXlVQqVZqdja+KvgEX8fnxOxc23S4W55eY0Ea59DZS/OUuLcMS34PPLE/JuVtw6X3CmypvkF69fiOEfJtCuK7o/3Mr4dtEQgj5Ni3G7oi2FV4DlQmB4d0hPvIAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "out of sync",
            "title": "out of sync",
            "src": "/ibm-cloudnative-journey/static/1910af2de6a3b8ba8fe6293f157d24a5/3cbba/out_of_sync.png",
            "srcSet": ["/ibm-cloudnative-journey/static/1910af2de6a3b8ba8fe6293f157d24a5/7fc1e/out_of_sync.png 288w", "/ibm-cloudnative-journey/static/1910af2de6a3b8ba8fe6293f157d24a5/a5df1/out_of_sync.png 576w", "/ibm-cloudnative-journey/static/1910af2de6a3b8ba8fe6293f157d24a5/3cbba/out_of_sync.png 1152w", "/ibm-cloudnative-journey/static/1910af2de6a3b8ba8fe6293f157d24a5/23e4c/out_of_sync.png 1578w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <ul>
          <li parentName="ul">{`Wait till the app is deployed.`}</li>
        </ul>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "51.041666666666664%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABS0lEQVQoz5WS2U7CQBSG+75GTQxR3CJGL4zeG30hvHCJC0YDghRa6Uw7U5aW7v0904hBXMBJvsxJm/nOPz3VKtsbeG7peO2YMC0OtfI8/8K8FWU5RkEE6QfQlpZXcFmr4+LuCVePDTB3CDEYEV6BQzWTA1jiF+id4fTR5hK67UJbXStBDD0EUQzpBdB5H3EcI4oTJGmGlOgwgXqX4cXgBPtGk543aFdom1s74MJFGIYYRwkMMSRJCi8IEJI4odqg7k2To/Vmz0UrrZdhyz58fwyfhC1LQrouLFvApkYqrUlXUelmD6smk0aTWitTwh4XcISkRClu6zqq1/eo3tSIB3Qt+0PIFku4u1cBcyQ8z6fvFqPdc9C2xCeT7tP7n8L9g0OMaNx5lhWDmI4/e6WFEh4dnxRCNYh4SjgrWVh4enZeCNU01a/zn8M/8Q7Xwt9i+0+CUwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "synched app",
            "title": "synched app",
            "src": "/ibm-cloudnative-journey/static/03f918ce36943230732e63f4259706af/3cbba/synched_app.png",
            "srcSet": ["/ibm-cloudnative-journey/static/03f918ce36943230732e63f4259706af/7fc1e/synched_app.png 288w", "/ibm-cloudnative-journey/static/03f918ce36943230732e63f4259706af/a5df1/synched_app.png 576w", "/ibm-cloudnative-journey/static/03f918ce36943230732e63f4259706af/3cbba/synched_app.png 1152w", "/ibm-cloudnative-journey/static/03f918ce36943230732e63f4259706af/ba1f3/synched_app.png 1574w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <ul>
          <li parentName="ul">{`Once the app is deployed, click on it to see the details.`}</li>
        </ul>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "39.583333333333336%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsSAAALEgHS3X78AAABVElEQVQoz22Q63KCMBCFeeNWW2s7vbxjdaa2IoRbJAkQIFzUP54u8VY7MvPNZje7Z09w3qYPmLk+VkGErCjhBzFWLMLSD4kALkWPai4LLV3fY7fbYbs9MJybrofUFVLCuR+N8OX54CJD228w8xjlAWIusCCBT7qbMwYvShDxFLe+/X5/iIRzNxqjbHvU7QZV00FVBlnVwPRbFKaFKGtkpoE2HUy3QUlR1y3lt3EeJ1MsY0FIrBIJjyv8RCm+w5SiQEDORV5CFBVCkR97L7g09xfr0F8rGiww92IsgsS6yeuGavlZkKsCQZrZ3iFfZxqJ0pRnVzjjx4l1xdKcxDgWIYcsDQlo6zjJtV0gdY2IFjASTfMKsSzgc2lFhvlhkU/ReXp+ORYPGxjhJsPzlW0cXKxJTNF/ldrY2ulumDmIXaLz+v5xVTydT9haoqzbgf93ZzPH8y/FdUhwIfQGjgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "sample app deployed",
            "title": "sample app deployed",
            "src": "/ibm-cloudnative-journey/static/ed3d6351842156b1ad02675f43c47981/3cbba/sample_app_deployed.png",
            "srcSet": ["/ibm-cloudnative-journey/static/ed3d6351842156b1ad02675f43c47981/7fc1e/sample_app_deployed.png 288w", "/ibm-cloudnative-journey/static/ed3d6351842156b1ad02675f43c47981/a5df1/sample_app_deployed.png 576w", "/ibm-cloudnative-journey/static/ed3d6351842156b1ad02675f43c47981/3cbba/sample_app_deployed.png 1152w", "/ibm-cloudnative-journey/static/ed3d6351842156b1ad02675f43c47981/23e4c/sample_app_deployed.png 1578w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "28.819444444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAAsSAAALEgHS3X78AAABH0lEQVQY021P2Y6DMBDj/z+uD7tqpQJJICQcgXJDu6u2XieobxvJmngyYzvRWWpIbdFPC7StkRUlRG4OZEXgmSmRKI1pWeHP6/XG+33g+Xxi2e9o5xXrzy+ii5AwVYNtf+Cc5fhOJHJT4ZprnJIUX0pCFBaSBtu+47/jhUMlomm7YybGZYMbZ7hhpuMDI3s1726a0U0rPnMD54Z5Q89Evga+HNxrRBdlEWt+teqg6xtE6SArh7ob4PoJxvVQZYuK/IPUOsRFjSv3fI2LBgkh2I9OV4VLZkKqnklU1UI3HcXGsJyT+15zGwNMc5gWrDW5bXvO3yBp6kNF3l0QqXEEnQzTUrDqRibmG3upbbg4hGVlm5DQC3pD5X9ELqw37vAHt2zBs7cBahEAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "sample app full deployment",
            "title": "sample app full deployment",
            "src": "/ibm-cloudnative-journey/static/72416f00d3f584833043748ee2a28954/3cbba/sample_app_full_deployment.png",
            "srcSet": ["/ibm-cloudnative-journey/static/72416f00d3f584833043748ee2a28954/7fc1e/sample_app_full_deployment.png 288w", "/ibm-cloudnative-journey/static/72416f00d3f584833043748ee2a28954/a5df1/sample_app_full_deployment.png 576w", "/ibm-cloudnative-journey/static/72416f00d3f584833043748ee2a28954/3cbba/sample_app_full_deployment.png 1152w", "/ibm-cloudnative-journey/static/72416f00d3f584833043748ee2a28954/a8e2d/sample_app_full_deployment.png 1577w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <h2>{`Verifying the deployment`}</h2>
        <ul>
          <li parentName="ul">{`Access the app to verify if it is correctly deployed.`}</li>
          <li parentName="ul">{`To allow access via LoadBalancer and leverage the `}<inlineCode parentName="li">{`minikube tunnel`}</inlineCode>{` running in the background, patch the argocd server service`}<pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`kubectl patch svc cloudnativesampleapp-service -p '{"spec": {"type": "LoadBalancer"}}'
`}</code></pre></li>
          <li parentName="ul">{`List the cloudnativesampleapp-service service`}<pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`kubectl get svc cloudnativesampleapp-service
`}</code></pre>{`  It should have an IP under `}<inlineCode parentName="li">{`EXTERNAL-IP`}</inlineCode>{` column`}<pre parentName="li"><code parentName="pre" {...{}}>{`NAME                           TYPE           CLUSTER-IP       EXTERNAL-IP      PORT(S)          AGE
cloudnativesampleapp-service   LoadBalancer   10.109.242.212   10.109.242.212   9080:31905/TCP   13m
`}</code></pre></li>
          <li parentName="ul">{`Set an environment variable `}<inlineCode parentName="li">{`APP_URL`}</inlineCode>{` using the `}<inlineCode parentName="li">{`EXTERNAL-IP`}</inlineCode><pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`export APP_URL="http://$(kubectl get svc cloudnativesampleapp-service -o jsonpath='{.status.loadBalancer.ingress[0].ip}'):9080"
echo ARGOCD_SERVER=$APP_URL
`}</code></pre></li>
          <li parentName="ul">{`Access the url using `}<inlineCode parentName="li">{`curl`}</inlineCode><pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`curl "$APP_URL/greeting?name=Carlos"
`}</code></pre><pre parentName="li"><code parentName="pre" {...{}}>{`{"id":2,"content":"Welcome to Cloudnative bootcamp !!! Hello, Carlos :)"}
`}</code></pre></li>
        </ul>
        <h2>{`Using the ArgoCD CLI`}</h2>
        <ul>
          <li parentName="ul">
            <p parentName="li">{`Login using the cli.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Login as the `}<inlineCode parentName="p">{`admin`}</inlineCode>{` user.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`The initial password is autogenerated to be the pod name of the Argo CD API server. This can be retrieved with the following command.`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`kubectl get pods -n argocd -l app.kubernetes.io/name=argocd-server -o name | cut -d'/' -f 2
`}</code></pre>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Now login as follows.`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`argocd login $ARGOCD_SERVER
`}</code></pre>
            <pre parentName="li"><code parentName="pre" {...{}}>{`WARNING: server certificate had error: x509: cannot validate certificate for 10.97.240.99 because it doesn't contain 
any IP SANs. Proceed insecurely (y/n)? y
Username: admin
Password: 
'admin' logged in successfully
Context '10.97.240.99' updated
`}</code></pre>
          </li>
          <li parentName="ul">
            <p parentName="li">{`List the applications`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`argocd app list
`}</code></pre>
            <pre parentName="li"><code parentName="pre" {...{}}>{`NAME    CLUSTER                         NAMESPACE  PROJECT  STATUS  HEALTH   SYNCPOLICY  CONDITIONS  REPO                                                                     PATH   TARGET
sample  https://kubernetes.default.svc  default    default  Synced  Healthy  <none>      <none>      https://github.com/ibm-cloud-architecture/cloudnative_sample_app_deploy  kubernetes  HEAD
`}</code></pre>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Get application details`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`argocd app get sample
`}</code></pre>
            <pre parentName="li"><code parentName="pre" {...{}}>{`Name:               sample
Project:            default
Server:             https://kubernetes.default.svc
Namespace:          default
URL:                https://10.97.240.99/applications/sample
Repo:               https://github.com/ibm-cloud-architecture/cloudnative_sample_app_deploy
Target:             HEAD
Path:               kubernetes
SyncWindow:         Sync Allowed
Sync Policy:        <none>
Sync Status:        Synced to HEAD (9684037)
Health Status:      Healthy

GROUP  KIND        NAMESPACE  NAME                             STATUS  HEALTH   HOOK  MESSAGE
    Service     default    cloudnativesampleapp-service     Synced  Healthy        service/cloudnativesampleapp-service created
apps   Deployment  default    cloudnativesampleapp-deployment  Synced  Healthy        deployment.apps/cloudnativesampleapp-deployment created
`}</code></pre>
          </li>
          <li parentName="ul">
            <p parentName="li">{`Show application deployment history`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`argocd app history sample
`}</code></pre>
            <pre parentName="li"><code parentName="pre" {...{}}>{`ID  DATE                           REVISION
0   2020-02-12 21:10:32 -0500 EST  HEAD (9684037)
`}</code></pre>
          </li>
        </ul>
        <h2>{`References`}</h2>
        <ul>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://argoproj.github.io/argo-cd/"
            }}>{`ArgoCD`}</a></li>
        </ul>
      </Tab>
    </Tabs>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      